import {
  identityPresignRequestSchema,
  identityPresignResponseSchema,
  identitySubmitRequestSchema,
  identitySubmitResponseSchema,
  identityWithdrawResponseSchema,
  phoneVerifyConfirmRequestSchema,
  phoneVerifyConfirmResponseSchema,
  phoneVerifyStartRequestSchema,
  phoneVerifyStartResponseSchema,
  userIdentitySelfSchema,
  type IdentityPresignRequest,
  type IdentitySubmitRequest,
  type PhoneVerifyConfirmRequest,
  type PhoneVerifyStartRequest,
} from "@chotca/config";
import type { RequestContext } from "./http";
import { requestJson } from "./http";

// Account identity (UserIdentity / CCCD) + account phone verification — SCRUM-71.
export function createIdentityResource(ctx: RequestContext) {
  return {
    getMyIdentity() {
      return requestJson(ctx, {
        method: "GET",
        path: "/me/identity",
        dataSchema: userIdentitySelfSchema.nullable(),
        auth: true,
      });
    },

    presignIdentity(body: IdentityPresignRequest) {
      const payload = identityPresignRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/identity/presign",
        body: payload,
        dataSchema: identityPresignResponseSchema,
        auth: true,
      });
    },

    submitIdentity(body: IdentitySubmitRequest) {
      const payload = identitySubmitRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/identity",
        body: payload,
        dataSchema: identitySubmitResponseSchema,
        auth: true,
      });
    },

    withdrawIdentity() {
      return requestJson(ctx, {
        method: "POST",
        path: "/me/identity/withdraw",
        dataSchema: identityWithdrawResponseSchema,
        auth: true,
      });
    },

    // Account phone verification (OTP via SCRUM-69 Zalo ZNS infra).
    startPhoneVerify(body: PhoneVerifyStartRequest) {
      const payload = phoneVerifyStartRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/phone/verify/start",
        body: payload,
        dataSchema: phoneVerifyStartResponseSchema,
        auth: true,
      });
    },

    confirmPhoneVerify(body: PhoneVerifyConfirmRequest) {
      const payload = phoneVerifyConfirmRequestSchema.parse(body);
      return requestJson(ctx, {
        method: "POST",
        path: "/me/phone/verify/confirm",
        body: payload,
        dataSchema: phoneVerifyConfirmResponseSchema,
        auth: true,
      });
    },
  };
}
